import { spark } from './abstract/spark';
import { halo } from './abstract/halo';
import { ticks } from './abstract/ticks';
import { dots } from './abstract/dots';
import { ripples } from './abstract/ripples';
import { swirl } from './abstract/swirl';
import { pinwheel } from './abstract/pinwheel';
import { chevrons } from './abstract/chevrons';
import { focus } from './abstract/focus';
import { braces } from './abstract/braces';
import { bars } from './abstract/bars';
import { waves } from './abstract/waves';
import { zigzag } from './abstract/zigzag';
import { sparkle } from './abstract/sparkle';
import { fringe } from './abstract/fringe';
import { layers } from './abstract/layers';

/** Abstract bodies, in picker order. */
export const ABSTRACT_BODIES = {
  spark,
  halo,
  ticks,
  dots,
  ripples,
  swirl,
  pinwheel,
  chevrons,
  focus,
  braces,
  bars,
  waves,
  zigzag,
  sparkle,
  fringe,
  layers,
};
